<div class="page-layout blank p-24" fusePerfectScrollbar>
    <h1 class="mt-5">{{title}}</h1>
    <p>Señor usuario, en estos momentos esta siendo redirigido al administrador de seguridad de B&A Systems para que pueda inciar sesión.</p>
    <p>En caso de no ser redirigido, de clic en el siguiente botón para ingresar al sistema</p>
    <p>
        <button mat-raised-button color="accent" (click)="login()">Ingresar <mat-icon class="ml-8">verified_user</mat-icon></button>
    </p>
</div>
